import React from 'react';
import { Route } from 'react-router-dom';

import IdaasCallback from './IdaasCallback';

interface MfaRoutesProps {
  baseUrl?: string;
}

/**
 * Defines routes for MFA Prompt.
 */
export default function MfaRoutes({ baseUrl }: MfaRoutesProps): JSX.Element {
  return (
    <Route
      path={`${baseUrl ?? ''}/gen2/mfa-prompt/idaas`}
      component={IdaasCallback}
    />
  );
}
